module.exports = __webpack_public_path__ + "static/media/ard-kka_interaktive_grafik_mobile.4aebb39f.jpg";